import Layout from './components/layout';
import Details from './components/AssetDetailsDialouge';
export default {
	Layout,
	Details
}